import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase'

import Layout from './Layout'
import HeroUnit from './hero-unit'
import Main from './main'

import 'sanitize.css'
import './App.scss'

class App extends Component {

  state = {
    suggestionsIndustry: [],
    suggestionsLocation: []
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (!nextProps.partners || nextProps.partners.length === 0) {
      return { 
        suggestionsIndustry: [],
        suggestionsLocation: []
      }
    }

    let suggestionsIndustry = nextProps.partners.reduce((acc, item) => {
      acc.push(
        item.name,
        item.info.category,
        ...item.info.services
      )
      return acc
    }, []).filter(a => a !== '-')

    const suggestionsLocation = nextProps.partners.reduce((acc, item) => {
      acc.push( item.info.city, item.info.country )
      return acc
    }, [])

    return { 
      suggestionsIndustry: [...new Set(suggestionsIndustry)],
      suggestionsLocation: [...new Set(suggestionsLocation)]
    }
  }

  render () {

    const { 
      partners
    } = this.props

    const empty = !isLoaded(partners)
      ? true
      : isEmpty(partners)

    return (
      <div>
        <Layout>
          <HeroUnit 
            suggestionsIndustry={this.state.suggestionsIndustry}
            suggestionsLocation={this.state.suggestionsLocation} />
          <Main 
            activePage={parseInt(this.props.match.params.pageNumber, 10)}
            results={this.props.partners}
            partnersEmpty={empty}
          />
        </Layout>
      </div>
    )
  }
}


export default compose(
  firebaseConnect([ '/companies' ]),
  connect((state, store) => {
    return {
      partners: state.firebase.data['companies']
    }
  })
)(App)


// WEBPACK FOOTER //
// ./src/components/App.jsx